export default {
  methods: {
    _mixin_generic_handleError(error) {
      console.error(error)
    },
  },
}
